import { render, staticRenderFns } from "./rizhi.vue?vue&type=template&id=fd0aa18a&scoped=true&"
import script from "./rizhi.vue?vue&type=script&lang=js&"
export * from "./rizhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0aa18a",
  null
  
)

export default component.exports